import { FC, memo } from 'react';
import classNames from 'classnames';

import Radio from '@zvuk-b2b/react-uikit/ui/Radio';

import { getDiscount, getIdSlug } from './utils';
import { PricePlanPeriodListProps } from './types';
import { TEXTS } from './texts';

import styles from './index.module.scss';

const PricePlanPeriodList: FC<PricePlanPeriodListProps> = ({
  pricePlan,
  currentPeriod,
  licensesCount,
  selectedPricePlanPeriodId,
  isPrimeAvailable,
  onPricePlanPeriodChange,
}) => (
  <div className={styles.pricePlanPeriodList}>
    {pricePlan?.periods.map((period) => {
      if (isPrimeAvailable && period.payFrequencyMonth === 12) {
        return <></>;
      }

      const currentDiscount = getDiscount(pricePlan, period, licensesCount);
      const isCurrentPeriod = currentPeriod?.id === period.id && selectedPricePlanPeriodId !== period.id;
      const idSlug = getIdSlug(isCurrentPeriod, period.payFrequencyMonth);
      const isChecked = selectedPricePlanPeriodId === period.id;

      return (
        <Radio
          key={`price_plan_period_item_${idSlug}`}
          elementId={`price_plan_period_item_${idSlug}`}
          isChecked={isChecked}
          className={classNames(styles.periodItem, {
            [styles.periodItemSelected]: isChecked,
          })}
          labelClassName={styles.discountLabel}
          onChange={() => onPricePlanPeriodChange({ period, rows: period.rows })}>
          <div>{period.title}</div>
          {currentDiscount > 0 && (
            <div
              data-testid={`price_plan_period_item_${idSlug}_discount`}
              className={styles.percent}>
              {TEXTS.CHANGE_PRICE_PLAN_PERIOD_MODAL_GIFT}
            </div>
          )}
        </Radio>
      );
    })}
  </div>
);

export default memo(PricePlanPeriodList);
